import z from 'zod'
export const BUNDLE_PRICING_TYPE = z.enum(['FIX', 'PERCENTAGE'])
export type BUNDLE_PRICING_TYPE = z.infer<typeof BUNDLE_PRICING_TYPE>
export interface BundleServicePayload {
  serviceId: string
  variantId: string
  sequence: number
}
export interface BundleService extends BundleServicePayload {
  id: string
  bundleId: string
}
export interface BundlePayload {
  name: string
  description: string
  pricingType: BUNDLE_PRICING_TYPE
  fixPrice: number
  percentage: number
  allowOnlineBooking: boolean
  services: BundleServicePayload[]
}
export interface Bundle extends BundlePayload {
  sequence: number
  createdAt: Date
  id: string
  services: BundleService[]
}

export interface BundleWithAvailable extends Bundle {
  haveAvailableTherapist: boolean
}

export interface ServiceItemData {
  name: string
  duration: number
  price: number
  color: string
  serviceId: string
  variantId: string
  priceDiscount: number
}
